<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" version="1.1" viewBox="-10 0 310 300">
    <g>
      <path stroke="null" id="svg_1" d="m155,114.04268l127.70732,124.95732l26.29268,-25.35366l-129.58537,-123.14634l-24.41463,-23.54268l-24.41463,23.54268l-129.58537,123.14634l26.29268,25.35366l127.70732,-124.95732z" fill="currentColor"/>
    </g>
  </svg>
</template>